import { render, staticRenderFns } from "./ApprovalClaimListHeader.vue?vue&type=template&id=100dd708"
import script from "./ApprovalClaimListHeader.vue?vue&type=script&lang=js"
export * from "./ApprovalClaimListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports